import { makeStyles } from '@material-ui/core/styles'

export default makeStyles(() => ({
  grid: {
    background: '#FFFFFF',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
    borderRadius: '7px',
    marginBottom: '20px',
    padding: '50px 20px 16px 20px',
    overflow: 'auto',
    maxWidth: '100%',
    position: 'relative',
  },
  drawerBox: {
    maxWidth: '1020px',
    overflowX: 'hidden',
    padding: '0 40px',
    height: '100%',
  },
  petBox: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  petImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  petNew: {
    width: '90px',
    height: '90px',
    borderRadius: '50%',
    border: 'none',
    margin: '8px',
    background: '#DFDFDF',
    color: '#FFFFFF',
    fontSize: '90px;',
    display: 'flex',
    justifyContent: 'center',
    textDecoration: 'none',
    alignItems: 'center',
    cursor: 'pointer',
  },
  pet: {
    width: '90px',
    cursor: 'pointer',
    textDecoration: 'none',
    height: '90px',
    borderRadius: '50%',
    border: 'none',
    background: '#CCD219',
    margin: '8px',
    fontSize: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#FFFFFF',
    position: 'relative',
    overflow: 'hidden',
    transition: 'all 150ms linear',
  },

  petEdit: {
    position: 'absolute',
    background: '#000',
    width: '100%',
    height: '100%',
    left: '0',
    top: '0',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '0',
    opacity: '0',
    transition: 'all 150ms linear',
    '&:hover': {
      opacity: '.5',
    },
  },
  petInactive: {
    width: '90px',
    cursor: 'pointer',
    textDecoration: 'none',
    height: '90px',
    borderRadius: '50%',
    border: '2px solid #FF6B6B',
    background: '#F5F5F5',
    margin: '8px',
    fontSize: '50px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#999999',
    position: 'relative',
    overflow: 'hidden',
    transition: 'all 150ms linear',
    opacity: '0.6',
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: '10%',
      right: '10%',
      height: '2px',
      background: '#FF6B6B',
      transform: 'translateY(-50%) rotate(-45deg)',
    },
  },
  petBoxInactive: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    opacity: '0.6',
    '& > *:last-child': {
      color: '#999999',
      textDecoration: 'line-through',
    },
  },
  filterContainer: {
    position: 'absolute',
    top: '16px',
    right: '20px',
    zIndex: 10,
    display: 'flex',
    alignItems: 'center',
    padding: '4px 8px',
    background: 'rgba(255, 255, 255, 0.9)',
    borderRadius: '20px',
    border: '1px solid #E9ECEF',
    backdropFilter: 'blur(4px)',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.1)',
  },
  switchLabel: {
    margin: '0',
    '& .MuiFormControlLabel-label': {
      fontSize: '12px',
      fontWeight: '400',
      color: '#666',
      marginLeft: '4px',
    },
    '& .MuiSwitch-root': {
      width: '32px',
      height: '20px',
      padding: '0',
    },
    '& .MuiSwitch-switchBase': {
      padding: '2px',
      '&.Mui-checked': {
        color: '#CCD219',
        transform: 'translateX(12px)',
        '& + .MuiSwitch-track': {
          backgroundColor: '#CCD219',
          opacity: 1,
        },
      },
    },
    '& .MuiSwitch-thumb': {
      width: '16px',
      height: '16px',
    },
    '& .MuiSwitch-track': {
      borderRadius: '10px',
      backgroundColor: '#E9ECEF',
      opacity: 1,
    },
  },
}))
